import { Center } from '@mantine/core';

const ZorroPayCardBackground = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="439"
        height="276"
        viewBox="0 0 439 276"
        fill="none"
        style={{ display: 'block', width: '100%', height: 'auto' }}
      >
        <g filter="url(#filter0_d_card)">
          <g clipPath="url(#clip0_card)">
            <rect
              x="9.34082"
              y="6.14917"
              width="420"
              height="256.92"
              rx="17.0711"
              fill="url(#paint0_linear_card)"
            />

            <g opacity="0.9" filter="url(#filter1_f_card)">
              <ellipse
                cx="268.259"
                cy="319.13"
                rx="268.259"
                ry="319.13"
                transform="matrix(-0.881193 -0.472756 -0.472756 0.881193 699.355 -148.209)"
                fill="url(#paint1_radial_card)"
              />
            </g>

            <g opacity="0.4" filter="url(#filter2_f_card)">
              <ellipse
                cx="24.6028"
                cy="211.212"
                rx="24.6028"
                ry="211.212"
                transform="matrix(-0.7149 -0.699227 -0.699227 0.7149 539.604 -114.164)"
                fill="url(#paint2_radial_card)"
              />
            </g>

            <g opacity="0.6" filter="url(#filter3_f_card)">
              <ellipse
                cx="53.88"
                cy="270.628"
                rx="214.057"
                ry="110.046"
                transform="rotate(6.41883 53.88 270.628)"
                fill="url(#paint3_radial_card)"
              />
            </g>

            <g
              filter="url(#filter4_n_card)"
              data-figma-bg-blur-radius="4.55531"
            >
              <rect
                x="9.34082"
                y="3.87079"
                width="420"
                height="261.68"
                rx="9.84375"
                fill="url(#paint4_linear_card)"
              />
              <rect
                x="9.5459"
                y="4.07587"
                width="419.59"
                height="261.27"
                rx="9.63867"
                stroke="url(#paint5_linear_card)"
                strokeWidth="0.410156"
              />
            </g>

            <g clipPath="url(#clip2_card)">
              <path
                d="M50.8077 42.6238V40.0901C50.8077 39.7206 50.5296 39.4204 50.1873 39.4204H42.822C42.4308 39.4204 42.1129 39.0773 42.1129 38.655V34.32C42.1129 34.1617 41.9937 34.033 41.847 34.033H36.8075C35.0441 34.033 33.6138 35.577 33.6138 37.4805V40.0835C33.6138 40.2419 33.733 40.3705 33.8797 40.3705H41.0402C41.6881 40.3705 41.9968 41.2316 41.517 41.7033L33.3968 49.6574C32.6633 50.3766 32.2446 51.3927 32.2446 52.4616V55.048C32.2446 55.4175 32.5227 55.7177 32.865 55.7177H40.2762C40.6674 55.7177 40.9852 56.0608 40.9852 56.4831V60.8742C40.9852 61.0325 41.1044 61.1612 41.2511 61.1612H46.419C48.1335 61.1612 49.521 59.6601 49.521 57.8126V55.114C49.521 54.9557 49.4018 54.827 49.2551 54.827H41.6728C41.1044 54.827 40.8355 54.0715 41.2572 53.6624L49.6586 45.4346C50.392 44.7154 50.8107 43.6993 50.8107 42.6304L50.8077 42.6238Z"
                fill="white"
              />
              <path
                d="M90.9623 47.5295C90.9623 52.3791 87.6587 55.9751 82.9919 55.9751C78.3252 55.9751 75.0215 52.3791 75.0215 47.5295C75.0215 42.6799 78.3252 39.1169 82.9919 39.1169C87.6587 39.1169 90.9623 42.7129 90.9623 47.5295ZM88.1721 47.5295C88.1721 43.6267 85.7547 41.5153 82.9889 41.5153C80.223 41.5153 77.8056 43.6267 77.8056 47.5295C77.8056 51.4323 80.223 53.58 82.9889 53.58C85.7547 53.58 88.1721 51.4686 88.1721 47.5295Z"
                fill="white"
              />
              <path
                d="M126.395 47.5295C126.395 52.3791 123.092 55.9751 118.425 55.9751C113.758 55.9751 110.455 52.3791 110.455 47.5295C110.455 42.6799 113.758 39.1169 118.425 39.1169C123.092 39.1169 126.395 42.7129 126.395 47.5295ZM123.605 47.5295C123.605 43.6267 121.188 41.5153 118.422 41.5153C115.656 41.5153 113.239 43.6267 113.239 47.5295C113.239 51.4323 115.656 53.58 118.422 53.58C121.188 53.58 123.605 51.4686 123.605 47.5295Z"
                fill="white"
              />
              <path
                d="M100.085 39.4171H97.3803C96.4268 39.4171 95.6567 40.2452 95.6567 41.2712V41.9409C95.6567 42.1916 95.4702 42.3962 95.238 42.4028H93.3798C93.1659 42.4028 92.9917 42.5908 92.9917 42.8217V55.4802C92.9917 55.5957 93.0773 55.6881 93.1842 55.6881H95.5008C95.7147 55.6881 95.8889 55.5 95.8889 55.2691V42.7921H95.892C95.9103 42.571 96.0753 42.3698 96.3229 42.3698H100.085C100.299 42.3698 100.473 42.1817 100.473 41.9508V39.8361C100.473 39.6052 100.299 39.4171 100.085 39.4171Z"
                fill="white"
              />
              <path
                d="M109.076 39.4171H106.372C105.418 39.4171 104.648 40.2452 104.648 41.2712V41.9409C104.648 42.1916 104.461 42.3962 104.229 42.4028H102.371C102.157 42.4028 101.983 42.5908 101.983 42.8217V55.4802C101.983 55.5957 102.068 55.6881 102.175 55.6881H104.492C104.706 55.6881 104.88 55.5 104.88 55.2691V42.7921H104.883C104.902 42.571 105.067 42.3698 105.314 42.3698H109.076C109.29 42.3698 109.464 42.1817 109.464 41.9508V39.8361C109.464 39.6052 109.29 39.4171 109.076 39.4171Z"
                fill="white"
              />
              <path
                d="M72.9463 42.8877C73.2916 42.4456 73.4811 41.8848 73.4811 41.3042V39.8394C73.4811 39.6118 73.31 39.4237 73.096 39.4237H61.0609C60.2113 39.4237 59.5237 40.166 59.5237 41.0831V41.8881C59.5237 42.0663 59.6276 42.218 59.7743 42.2741H69.6609C69.829 42.2741 69.9085 42.4984 69.7832 42.6205L59.7223 52.2472C59.377 52.6892 59.1875 53.2501 59.1875 53.8307V55.2955C59.1875 55.5231 59.3586 55.7112 59.5726 55.7112H71.8888C72.7385 55.7112 73.4261 54.9689 73.4261 54.0517V53.2303C73.4261 53.0026 73.2549 52.8146 73.041 52.8146H63.0169C62.8488 52.8146 62.7693 52.5903 62.8946 52.4682L72.9463 42.8844V42.8877Z"
                fill="white"
              />
            </g>

            <path
              d="M362.148 221.263L352.748 245.184H346.612L341.99 226.096C341.705 224.919 341.462 224.49 340.609 223.99C339.211 223.185 336.912 222.429 334.882 221.958L335.024 221.263H344.895C346.154 221.263 347.286 222.159 347.57 223.703L350.014 237.548L356.051 221.263H362.148ZM386.179 237.371C386.207 231.061 377.992 230.717 378.051 227.894C378.067 227.033 378.833 226.121 380.51 225.891C381.343 225.773 383.635 225.686 386.233 226.958L387.251 221.887C385.853 221.346 384.057 220.828 381.824 220.828C376.089 220.828 372.052 224.081 372.018 228.736C371.98 232.178 374.898 234.099 377.099 235.245C379.359 236.418 380.115 237.167 380.107 238.219C380.092 239.825 378.304 240.526 376.635 240.558C373.718 240.606 372.025 239.717 370.673 239.046L369.623 244.29C370.977 244.953 373.483 245.529 376.078 245.563C382.173 245.563 386.16 242.344 386.179 237.371ZM401.324 245.185H406.692L402.008 221.263H397.053C395.939 221.263 395 221.956 394.582 223.017L385.881 245.185H391.971L393.18 241.612H400.625L401.324 245.185ZM394.849 236.709L397.905 227.727L399.663 236.709H394.849ZM370.44 221.263L365.639 245.184H359.835L364.637 221.263H370.44Z"
              fill="white"
            />

            <rect
              x="84.6839"
              y="92.1823"
              width="34.6799"
              height="52.2328"
              rx="3.97061"
              transform="rotate(90 84.6839 92.1823)"
              fill="url(#paint6_radial_card)"
              stroke="#3C0789"
              strokeWidth="0.427188"
            />
            <path
              d="M68.2592 92.1088L68.2592 99.0374C68.2592 99.4795 68.1892 99.9187 68.0517 100.339L66.6755 104.544M66.6755 104.544L66.6755 114.993M66.6755 104.544L84.6602 104.544M66.6755 114.993L68.0237 118.84C68.1796 119.285 68.2592 119.753 68.2592 120.224L68.2592 126.852M66.6755 114.993L84.6602 114.993M48.576 92.1088L48.576 98.7924C48.576 99.3935 48.7055 99.9876 48.9557 100.534L50.8896 104.758M50.8896 104.758L50.8896 110.809C50.8896 113.12 49.0163 114.993 46.7054 114.993L32.6029 114.993M50.8896 104.758L32.6029 104.758M48.576 119.512L48.576 126.852"
              stroke="#3C0789"
              strokeWidth="0.427188"
            />
          </g>
        </g>

        <defs>
          <filter
            id="filter0_d_card"
            x="9.44138e-05"
            y="-6.4373e-06"
            width="438.681"
            height="275.601"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3.19155" />
            <feGaussianBlur stdDeviation="4.67036" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_card"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_card"
              result="shape"
            />
          </filter>

          <filter
            id="filter1_f_card"
            x="-13.9218"
            y="-347.933"
            width="652.037"
            height="708.237"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="22.7766"
              result="effect1_foregroundBlur_card"
            />
          </filter>
          <filter
            id="filter2_f_card"
            x="180.034"
            y="-177.911"
            width="388.593"
            height="395.079"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="22.7766"
              result="effect1_foregroundBlur2_card"
            />
          </filter>
          <filter
            id="filter3_f_card"
            x="-204.75"
            y="113.107"
            width="517.261"
            height="315.041"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="22.7766"
              result="effect1_foregroundBlur3_card"
            />
          </filter>

          <filter
            id="filter4_n_card"
            x="-36.2123"
            y="-41.6824"
            width="511.106"
            height="352.786"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.5488095 0.5488095"
              stitchTiles="stitch"
              numOctaves={3}
              result="noise"
              seed={6352}
            />
            <feColorMatrix
              in="noise"
              type="luminanceToAlpha"
              result="alphaNoise"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA
                type="discrete"
                tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
              />
            </feComponentTransfer>
            <feComposite
              operator="in"
              in2="shape"
              in="coloredNoise1"
              result="noise1Clipped"
            />
            <feFlood floodColor="rgba(255,255,255,0.1)" result="color1Flood" />
            <feComposite
              operator="in"
              in2="noise1Clipped"
              in="color1Flood"
              result="color1"
            />
            <feMerge result="effect1_noise_card">
              <feMergeNode in="shape" />
              <feMergeNode in="color1" />
            </feMerge>
          </filter>

          <linearGradient
            id="paint0_linear_card"
            x1="-149.191"
            y1="-73.5401"
            x2="433.588"
            y2="263.069"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3C0789" />
            <stop offset="1" stopColor="#9859F2" />
          </linearGradient>

          <radialGradient
            id="paint1_radial_card"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(268.259 319.13) rotate(90) scale(319.13 268.259)"
          >
            <stop stopColor="#00D16C" />
            <stop offset="1" stopColor="#00D16C" stopOpacity="0" />
          </radialGradient>

          <radialGradient
            id="paint2_radial_card"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(24.6028 211.212) rotate(90) scale(211.212 24.6028)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>

          <radialGradient
            id="paint3_radial_card"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(53.8801 270.628) rotate(90) scale(110.046 214.057)"
          >
            <stop stopColor="#E0E3FE" />
            <stop offset="1" stopColor="#9E5AFF" stopOpacity="0" />
          </radialGradient>

          <linearGradient
            id="paint4_linear_card"
            x1="591.968"
            y1="337.328"
            x2="-41.9287"
            y2="-120.202"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" stopOpacity="0.2" />
          </linearGradient>

          <linearGradient
            id="paint5_linear_card"
            x1="20.415"
            y1="3.8708"
            x2="436.929"
            y2="10.0231"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.2" />
            <stop offset="1" stopColor="#979CCC" stopOpacity="0.3" />
          </linearGradient>

          <radialGradient
            id="paint6_radial_card"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(40.3189 80.8066 -651.96 1334.3 91.7821 95.0079)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E0E3FE" />
            <stop offset="1" stopColor="#EDEFF6" />
          </radialGradient>

          <clipPath id="clip0_card">
            <rect
              x="9.34082"
              y="6.14917"
              width="420"
              height="256.92"
              rx="17.0711"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2_card">
            <rect
              width="94.1507"
              height="27.1282"
              fill="white"
              transform="translate(32.2446 34.033)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};

export { ZorroPayCardBackground };
